import React, { useState } from "react";
import { PageHeader } from "@/components/site/kit";
import Newsletter from "@/components/site/Newsletter";
import ShopifyProducts from "@/components/shop/ShopifyProducts";
import CartDrawer from "@/components/shop/CartDrawer";
import { Sparkles } from "lucide-react";
import SEO, { breadcrumbSchema } from "@/components/site/SEO";

export default function Recommended() {
  const [shopify, setShopify] = useState(null);
  return (
    <div data-testid="shop-page">
      <SEO
        title="Shop — AVENO Everyday Goods | Julius Mason"
        description="Shop AVENO: organic apparel, drinkware, stationery, home goods and a kids & baby line — designed by Julius Mason, modeled by his family, shipped worldwide via Shopify."
        path="/shop"
        lang="en"
        keywords="AVENO shop, everyday goods, organic apparel, kids clothing, buy aveno"
        schema={breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Shop", path: "/shop" },
        ])}
      />
      <PageHeader
        chapter="Shop / AVENO"
        titleLines={["Everyday goods.", "Made properly."]}
        description="My own products — designed by me, modeled by my family, shipped worldwide. Click any product for the full story, then check out securely via Shopify."
      />

      <ShopifyProducts onLoaded={setShopify} />
      <CartDrawer checkoutBase={shopify?.checkout_base} currency={shopify?.currency} />

      <section className="py-16 border-t border-slate-100 bg-slate-50/40">
        <div className="mx-auto max-w-2xl px-6 md:px-12 text-center">
          <Sparkles className="w-8 h-8 text-primary mx-auto mb-4" />
          <h2 className="font-display text-3xl md:text-4xl mb-4">Get the drop alerts</h2>
          <p className="text-slate-600 mb-8">New designs, restocks, and launch deals — sent when they&apos;re actually worth it.</p>
          <Newsletter source="shop" />
        </div>
      </section>
    </div>
  );
}
